import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";
import { toast } from "react-toastify";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";

export default function RiskConvertIssueList() {
  const [riskIssueList, setRiskIssueList] = useState([]);

  const getRiskIssueData = async () => {
    const state = JSON.parse(localStorage.getItem("state"));
    setCurrentPage(1);
    let obj = {
      UserID: state.user.user_id,

      //Filters Optional

      //   ProjectName: "",
      //   ProductCategory: "",
      //   Activity_task: openFilter ? riskFilter.Activity_task : "",
      //   Location: "",
      //   RiskDueDate: openFilter ? riskFilter.RiskDueDate : "",
      //   RiskDescription: "",
      //   ImpactDescription: "",
      //   ImpactLevel: openFilter ? riskFilter.ImpactLevel : "",
      //   RiskStatus: openFilter ? riskFilter.RiskStatus : "",
      //   StartDate: openFilter ? riskFilter.StartDate : "",
      //   EndDate: openFilter ? riskFilter.EndDate : "",
      IsRiskintoIssue: "Yes",
    };
    const risk = await DPR_API.GetIssueAllocationDetails(obj);
    if (risk.status === 200) {
      setRiskIssueList(risk.IssueList);
    } else {
      setRiskIssueList([]);
    }
  };

  useEffect(() => {
    getRiskIssueData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(riskIssueList.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = riskIssueList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <>
      {/* <div className="row" style={{ marginRight: 25 }}>
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={riskIssueList?.map((val) => {
                return {
                  "Project Name": val?.ProjectName,
                  "Product Category": val?.ProductCategory,
                  "Project Location": val?.Location,
                  "Impact Level": val?.ImpactLevel,
                  "Risk Due Date": val?.RiskDueDate,
                  "Risk Status": val?.RiskStatus,
                };
              })}
              fileName="Risk list"
              sheet="Risk"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpenFilter(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div
            className="my-auto"
            onClick={() => {
              setRiskFilter({
                ProjectName: "",
                ProductCategory: "",
                Activity_task: "",
                Location: "",
                RiskDueDate: "",
                RiskDescription: "",
                ImpactDescription: "",
                ImpactLevel: "",
                RiskStatus: "",
              });
              setTimeout(() => {
                getRiskIssueData();
                setCurrentPage(1);
              }, 500);
            }}
          >
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div> */}
      <div className="table-container">
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th>Sr No</th>
              <th>Project Name</th>
              <th>Product Category</th>
              <th>Project Location</th>
              <th>Impact Level</th>
              {/* <th>Risk Due Date</th> */}
              <th>Risk Status</th>
              <th>Created Date</th>
              {/* <th>Action</th> */}
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td id="elps" title={row.ProjectName}>
                  {row.ProjectName}
                </td>
                <td id="elps" title={row.ProductCategory}>
                  {row.ProductCategory ? row.ProductCategory : "-"}
                </td>
                <td id="elps" title={row.ProjectLocation}>
                  {row.Location ? row.Location : "-"}
                </td>
                <td id="elps" title={row.ImpactLevel}>
                  {row.ImpactLevel ? row.ImpactLevel : "-"}
                </td>
                {/* <td id="elps" title={row.RiskDueDate}>
                  {row.RiskDueDate
                    ? new Date(row?.RiskDueDate).toLocaleDateString("en-GB")
                    : "-"}
                </td> */}
                <td id="elps" title={row.IssueStatus}>
                  {row.IssueStatus ? row.IssueStatus : "-"}
                </td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString("en-GB")}</td>
                {/* <td style={{ cursor: 'pointer' }}>
                                <img src={Add} width={20} onClick={onOpenModal} />
                            </td> */}
                {/* <td>
                  <button
                    className="btn btn-primary"
                    onClick={(e) => {
                      handleConvertClick(row);
                    }}
                  >
                    Convert to Issue
                  </button>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min(
              (currentPage - 1) * rowsPerPage + 1,
              riskIssueList.length
            )}{" "}
            to {Math.min(currentPage * rowsPerPage, riskIssueList.length)} of{" "}
            {riskIssueList.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            {/* Left Arrow */}
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow} // Replace with your actual image path
                alt="Previous"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {/* Page Numbers */}
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}

            {/* Right Arrow */}
            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow} // Replace with your actual image path
                alt="Next"
                height="11px"
                width="7px"
                style={{
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
